module.exports = __webpack_public_path__ + "img/preSessionSuccess.83a5ce24.png";